import React from "react";
import LocationDropdown from './LocationDropdown'

export default function Preferences (props) {
  return (
    <div className="user-panel">
      <div className='formintro h6'>Preferences</div>
      <div className="formLabel">Location Description</div>
      <LocationDropdown {...props} />
    </div>
  )
}